import AssetService from './AssetService';
// file to choose service implementations in case
import {IPortfolioService} from './IPortfolioService';
import SftAuthService from './SftAuthService';
import SftPortfolioService from './SftPortfolioService';
import SftRecommendService from './SftRecommendService';

export const assetService = new AssetService();

export const authService = new SftAuthService();
export const portfolioService = new SftPortfolioService(authService);
export const recommendService = new SftRecommendService(authService);
